var _path, _g, _g2, _g3, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 63.7411H14.5002C15.3286 63.7411 16.0002 64.4127 16.0002 65.2411V76.8864C16.0002 78.1428 17.4524 78.8425 18.435 78.0596L35.9946 64.068C36.2602 63.8564 36.5897 63.7411 36.9293 63.7411H56.0014C60.4135 63.7411 64.0016 60.1675 64.0016 55.7732V23.9015C64.0016 19.5072 60.4135 15.9336 56.0014 15.9336H7.99999C3.58786 15.9336 -0.000244141 19.5072 -0.000244141 23.9015V55.7732C-0.000244141 60.1675 3.58786 63.7411 7.99999 63.7411Z",
    fill: "url(#paint0_linear_26392_40150)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26392_40150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4539 45.9103C18.4665 45.9103 20.9086 43.4682 20.9086 40.4557C20.9086 37.4431 18.4665 35.001 15.4539 35.001C12.4414 35.001 9.99927 37.4431 9.99927 40.4557C9.99927 43.4682 12.4414 45.9103 15.4539 45.9103Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26392_40150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3628 45.9103C34.3753 45.9103 36.8174 43.4682 36.8174 40.4557C36.8174 37.4431 34.3753 35.001 31.3628 35.001C28.3502 35.001 25.9081 37.4431 25.9081 40.4557C25.9081 43.4682 28.3502 45.9103 31.3628 45.9103Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26392_40150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2734 45.9103C50.2859 45.9103 52.7281 43.4682 52.7281 40.4557C52.7281 37.4431 50.2859 35.001 47.2734 35.001C44.2609 35.001 41.8187 37.4431 41.8187 40.4557C41.8187 43.4682 44.2609 45.9103 47.2734 45.9103Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.9999 0.000976562H23.9985C19.5864 0.000976562 15.9983 3.57459 15.9983 7.9689H63.9997C68.4118 7.9689 71.9999 11.5425 71.9999 15.9368V47.8085C76.412 47.8085 80.0001 44.2349 80.0001 39.8406V7.9689C80.0001 3.57459 76.412 0.000976562 71.9999 0.000976562Z",
    fill: "url(#paint1_linear_26392_40150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26392_40150",
    x: -34.0748,
    y: -9.07311,
    width: 99.0575,
    height: 99.0574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 22.037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26392_40150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26392_40150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26392_40150",
    x: -18.166,
    y: -9.07311,
    width: 99.0575,
    height: 99.0574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 22.037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26392_40150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26392_40150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26392_40150",
    x: -2.25536,
    y: -9.07311,
    width: 99.0575,
    height: 99.0574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 22.037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26392_40150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26392_40150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26392_40150",
    x1: -1.33362,
    y1: 8.25901,
    x2: 63.7407,
    y2: 80.9358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26392_40150",
    x1: -50.6703,
    y1: -11.4529,
    x2: 39.6041,
    y2: 123.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/empty-chat.b1409c60b571c5b645cb9fe7777be1cf.svg";
export { ForwardRef as ReactComponent };